import React from "react";
import Grid from "@mui/material/Grid";
// import Paper from "@mui/material/Paper";
// import { Table } from "react-bootstrap";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import ReusableDataGrid from "../../components/Tickets";
import axios from "axios";

const Dashboard = () => {
  const [data, setData] = React.useState([]);
  // Sample data
  const rows = [
    { id: 1, name: "John Doe", age: 25, occupation: "Developer" },
    { id: 2, name: "Jane Smith", age: 30, occupation: "Designer" },
    { id: 3, name: "Alice Johnson", age: 28, occupation: "Manager" },
  ];

  const getTickets = () => {
    axios(`${process.env.REACT_APP_API_URL}/support-management/ticket`)
      .then((response) => {
        console.log(response.data);
        setData(response.data.tickets.map((ticket) => {
          return {
            id: ticket._id,
            ticketId: ticket.ticketId,
            subject: ticket.subject,
            category: ticket.category,
            priority: ticket.priority,
            createdAt: ticket.createdAt,
            updatedAt: ticket.updatedAt,
            status: ticket.status,
          };
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  }

  React.useEffect(() => {
    getTickets();
  }, []);

  const initialData = [
    {
      id: "1",
      ticketId: "T-1001",
      subject: "Login Issue",
      category: "Technical",
      priority: "High",
      createdAt: "2024-01-01",
      updatedAt: "2024-01-02",
      status: "Open",
    },
    {
      id: "2",
      ticketId: "T-1002",
      subject: "Payment Error",
      category: "Billing",
      priority: "Medium",
      createdAt: "2024-01-03",
      updatedAt: "2024-01-04",
      status: "Resolved",
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4} lg={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 100,
          }}
        >
          {/* <Chart /> */}
          <h2>Today Tickets</h2>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 100,
          }}
        >
          {/* <Chart /> */}
          <h2>Open Tickets</h2>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 100,
          }}
        >
          {/* <Deposits /> */}
          <h2>Closed Tickets</h2>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          {/* <Orders /> */}
          {/* <h1>Recent Tickets</h1> */}
          <ReusableDataGrid data={data} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
